import React from 'react';
import styled from 'styled-components';
import SelectBox from './SelectBox';
import { SelectType, PerPage } from '../enum/EnumRepository';

interface PageSizeStationProps {
  currentValue: PerPage;
  handlePerPageChange: (value: PerPage) => void;
  direction: boolean; //true: UP, false: DOWN
}

const PageSizeStation: React.FC<PageSizeStationProps> = ({
  handlePerPageChange,
  currentValue = PerPage.PAGE_10,
  direction = false,
}) => {
  return (
    <PageSizeStationComp>
      <PageSizeText>
        Per : 
      </PageSizeText>
      <SelectBoxWrapper>
        <SelectBox
          value={currentValue}
          selectType={SelectType.PER_PAGE}
          handleChange={handlePerPageChange}
          direction={direction} />
      </SelectBoxWrapper>
    </PageSizeStationComp>
  );
};

export default PageSizeStation;

const PageSizeStationComp = styled.section`
  width: fit-content;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
`;

const PageSizeText = styled.div`
  width: clamp(25px, 3vw, 30px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Footer_02};
  user-select: none;
`;

const SelectBoxWrapper = styled.div`
  width: clamp(35px, 3.5vw, 45px);
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Footer_02};
`;
